import React, {Suspense, memo} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"
import {Wrapper} from "./component"
import TestTools from "../TestTools"

export type SecureHeaderWrapperProps = {
    children: React.ReactNode
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
    displayTestTools: boolean
}

export const SecureHeaderWrapper = memo(({children, templating, displayTestTools}: SecureHeaderWrapperProps) => {
    const {mainTemplate, fallbackTemplate} = templating
    const TemplatedComponent = useTemplatedComponent({mainTemplate, fallbackTemplate}, MANIFEST)
    return (
        <Wrapper data-testid="header-secure-header-wrapper">
            {displayTestTools && <TestTools />}
            <Suspense>
                <TemplatedComponent>{children}</TemplatedComponent>
            </Suspense>
        </Wrapper>
    )
})

SecureHeaderWrapper.displayName = "SecureHeaderWrapper"

export default connect(SecureHeaderWrapper)
